import React from 'react';

import {
  UserCircleIcon,
  DotHorizontalIcon,
  KeyIcon,
  LogOutIcon,
} from 'shared/ui/icons';

/**
 * Sidebar profile block: avatar, name/email, and the change-password / logout
 * popover. Extracted verbatim from `Sidebar.jsx` (SA-1862) so the super-admin
 * Konfigurasi Klaim sidebar renders the exact same profile affordances instead
 * of a second copy that can drift.
 */
export function UserInfo({
  isMobile,
  isPopoverOpen,
  handleTogglePopover,
  handleChangePassword,
  handleLogout,
  profileName,
  profileEmail,
  popoverRef,
  t,
}) {
  return (
    <div
      className="w-full flex bg-neutral-800 rounded-lg gap-2 items-center p-3 mt-4 cursor-pointer"
      ref={popoverRef}
      onClick={handleTogglePopover}
    >
      <div className="flex-none bg-white h-8 w-8 rounded-full flex items-center justify-center">
        <span>
          <UserCircleIcon />
        </span>
      </div>
      <div className="grow flex flex-col text-xs text-white truncate">
        <span className="font-semibold">{profileName || 'Guest'}</span>
        <span>{profileEmail || 'example@gmail.com'}</span>
      </div>
      <div className="flex-none cursor-pointer">
        <DotHorizontalIcon width="16" color="#ffffff" />
      </div>
      {isPopoverOpen && (
        <div
          className={`${isMobile ? 'right-4 bottom-20' : 'bottom-5 left-[17vw]'} absolute w-44 bg-white border rounded-lg shadow-lg z-50`}
        >
          <ul className="py-4 flex gap-2 flex-col">
            <li className="px-4 py-1 hover:bg-gray-100 text-sm">
              <button
                type="button"
                onClick={handleChangePassword}
                className="w-full text-left cursor-pointer flex flex-wrap items-center gap-2"
              >
                <KeyIcon />
                <span className="text-black">{t('change_password')}</span>
              </button>
            </li>
            <li className="px-4 py-1 hover:bg-gray-100 text-sm">
              <button
                type="button"
                onClick={handleLogout}
                className="w-full text-left cursor-pointer flex flex-wrap items-center gap-2"
              >
                <LogOutIcon />
                <span className="text-black">{t('logout')}</span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
